module.exports = __webpack_public_path__ + "e8cfb8e4c3188f0ebbcb54145039d53f.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo_cabin.svg
// module id = 211
// module chunks = 0